/**
 * Service-Worker-Uebernahme: nach einem Deploy einmal neu laden.
 *
 * Kontor ist eine PWA. Der Service Worker legt `index.html` in den Precache und
 * beantwortet jede Navigation daraus (`navigateFallback`). Nach einem Deploy
 * bekommt der Browser deshalb zuerst die ALTE Seite mit dem alten Bundle —
 * der neue Worker installiert sich zwar im Hintergrund und uebernimmt dank
 * `skipWaiting()` + `clientsClaim()` sofort, aber die bereits gerenderte Seite
 * laeuft weiter auf dem alten Code. Genau das war der Effekt nach der
 * Google-Rueckkehr: die Einstellungsseite blieb auf dem alten Stand, erst ein
 * Neuladen von Hand half.
 *
 * Das erzeugte `registerSW.js` von vite-plugin-pwa registriert nur und laedt
 * nicht neu. Deshalb hier: auf den Wechsel des Controllers hoeren und die Seite
 * genau einmal neu laden.
 *
 * Zwei Absicherungen, damit daraus keine Schleife wird:
 *   - Nur wenn beim Laden schon ein Controller da WAR. Beim allerersten Besuch
 *     wechselt der Controller von "keiner" auf "einer" — das ist kein Update.
 *   - Ein Merker pro Seitenaufruf; nach dem Neuladen ist der neue Worker bereits
 *     der Controller, ein zweiter Wechsel kommt nicht.
 */
export function serviceWorkerNeuladenBeiUpdate(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  const hatteSchonEinenController = !!navigator.serviceWorker.controller;
  if (!hatteSchonEinenController) return;

  let laedtSchon = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (laedtSchon) return;
    laedtSchon = true;
    window.location.reload();
  });
}
